// import settings from '../settings.json';
let settings = require('../settings.json');
let KP = settings.kp;
let BASE_URL;
let WS_STR;

if (process.env.NODE_ENV == 'production') {
    BASE_URL = settings.prod.baseUrl || `api/v${settings.api}`;
    WS_STR = settings.prod.wsUrl || `ws://${location.host}/ws/${settings.kp}`;

} else {
    BASE_URL = `${location.protocol}//${settings.dev.host}:${settings.dev.wrtPort}/api/v${settings.api}`;
    WS_STR = `ws://${settings.dev.host}:${settings.dev.wsPort}/ws/${settings.kp}`;
}
export {KP, BASE_URL, WS_STR};


// WEBPACK FOOTER //
// ./src/settings.js